import BaseStore from './BaseStore';

export type ScreenshotPreviewStoreType = {
  screenshotUrl: string;
  show: boolean;
};

const InitialState: ScreenshotPreviewStoreType = {
  screenshotUrl: '',
  show: false
};

class ScreenshotPreviewStore extends BaseStore<ScreenshotPreviewStoreType> {
  constructor() {
    super(InitialState);
  }

  public openPreview(screenshotUrl: string): void {
    this.store.update((state) => {
      state.show = true;
      state.screenshotUrl = screenshotUrl;
      return state;
    });
  }
}

export const screenshotPreviewStore = new ScreenshotPreviewStore();
